import React from 'react';
import { api } from "api";
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { validate, validators } from 'validate-redux-form';
import { renderField, renderSearchSelect, renderCurrency } from 'Utils/renderField/renderField';
import trim from 'lodash/trim';
import validarNit from 'validar-nit-gt';

export const isEmpty = value => value === undefined || value === null || value === '';
export function NIT(value) {
    if (!isEmpty(value)) {
        value = trim(value.toUpperCase())
        return validarNit(value) ? null : value === 'CF' ? null : 'Escriba un nit válido o CF'
    }
    return null
}

let subsidiaries = []
const getSubsidiaries = (search)  =>{
    return api.get("subsidiaries",{search}).catch((error) => {})
        .then((data) => {
            if (data){
                subsidiaries = [];
                data.results.forEach(x=>{
                    subsidiaries.push({value: x.id, label: x.name})
                })
                return subsidiaries
            }
            else{
                return []
            }
        })
        .catch(e => {
            return []
        })
}

const Form = props => {

    const {
        handleSubmit
    } = props;

    const view = window.location.href.includes("view");
    const edit = window.location.href.includes("edit");

    return(
        <form onSubmit={handleSubmit} className="py-3 px-5">
            <div className="px-md-5 d-flex justify-content-around flex-column flex-sm-row align-items-stretch align-items-sm-center">
                <div className="m-2">
                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <label htmlFor="name" className="">Nombre de la caja chica</label>
                    </div>
                    <div className=" d-flex justify-content-center flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <Field name="name" disabled={view} autofocus component={renderField} type="text" className="form-control"/>
                    </div>
                </div>
                <div className="m-2">
                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <label htmlFor="subsidiary" className="m-0">Sucursal</label>
                    </div>
                    <div className=" d-flex justify-content-end flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <Field
                            name="subsidiary"
                            valueKey="value"
                            labelKey="label"
                            label="name"
                            component={renderSearchSelect}
                            loadOptions={getSubsidiaries}
                            className="no-border"
                            disabled={ view || edit }
                        />
                    </div>
                </div>
            </div>
            <div className="px-md-5 d-flex justify-content-around flex-column flex-sm-row align-items-stretch align-items-sm-center">
                <div className="m-2">
                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <label htmlFor="name" className="">Nit</label>
                    </div>
                    <div className=" d-flex justify-content-center flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <Field
                            name="nit"
                            disabled={view}
                            component={renderField}
                            type="text"
                            className="form-control"
                            validate={NIT}
                        />
                    </div>
                </div>
                <div className="m-2">
                    <div className="d-flex justify-content-start flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <label htmlFor="limite" className="">Monto máximo de Caja Chica</label>
                    </div>
                    <div className=" d-flex justify-content-center flex-column flex-sm-row align-items-stretch align-items-sm-center">
                        <Field name="limit" disabled={view} component={renderCurrency} className="form-control"/>
                    </div>
                </div>
            </div>
            <div className="row-fluid">
                <div className="d-flex justify-content-center flex-column flex-sm-row align-items-stretch align-items-sm-center">
                    <Link className="btn btn-secondary m-3" to="/small-box">{!view ? ("Cancelar") : ("Regresar")}</Link>
                   {!view && (<button type="submit" className="btn btn-primary m-3">Guardar</button>)}
                </div>
            </div>
        </form>
    )
};

const SmallBoxForm = reduxForm({
    form: 'smallBox',
    validate: data => {
        return validate(data, {
           'name': validators.exists()('Campo requerido.'),
           'nit': validators.exists()('Campo requerido.'),
           'subsidiary': validators.exists()('Compo requerido'),
           'limit': validators.exists()('Compo requerido'),
        })
    }
})(Form);

export default SmallBoxForm;
